import './polyfill';
import externalLinks from './modules/externalLinks';
import navigation from './layout/navigation';
import contentSets from './content-sets';
import smoothScroll from './smooth-scroll';
import animatedCar from './animated-car';
import appLayout from './layout/app';
import accordion from './layout/accordion';

document.addEventListener('DOMContentLoaded', function () {
  externalLinks();
  navigation();
  contentSets();
  smoothScroll();
  animatedCar();
  appLayout();
  accordion();
});
